import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { LocalStorageService } from 'ngx-webstorage';
import { catchError, finalize, Observable, throwError } from "rxjs";
import { storageKeys } from "../../shared/utility/utility";
import { environment } from '../../../environments/environment';
import { NotificationService } from "../services/notification.service";
import { SpinnerService } from "../services/spinner.service";


export function coreInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  const storage:LocalStorageService= inject(LocalStorageService);
  const _notificationService: NotificationService= inject(NotificationService);
  const _spinnerService: SpinnerService = inject(SpinnerService);
  const token: string = storage.retrieve(storageKeys.TOKEN);
  const urlPrefix = environment.apiBaseUrl;

  let update: {url: string, setHeaders?: {[key: string]: string}} = {url: urlPrefix + req.url};
  if(!!token) {
    update.setHeaders = {Authorization: `Bearer ${token}`}
  }
  _spinnerService.show();
  req = req.clone(update);

  return next(req).pipe(
    finalize(() => _spinnerService.hidden()),
    catchError((err: HttpErrorResponse) => {
      const errorMessage = err.error.errorMessage;
      const error = errorMessage ? errorMessage : 'Si è verificato un errore , riprovare più tardi.';
      
      _notificationService.errorSnackBar(error);

      return throwError(() => err);
    })
  );


  //gestione degli errori

}
